import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Typography } from "@mui/material";
import Cancel from "@mui/icons-material/Cancel";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";

export class ComponentsModule_Chip_Level extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Information", "Positive", "MinorWarning", "Warning", "Critical", "Neutral"];
    }
}

export function ComponentsModule_Chip_Level_$reflection() {
    return union_type("Kundeweb.ComponentsModule.Chip.Level", [], ComponentsModule_Chip_Level, () => [[], [], [], [], [], []]);
}

export function ComponentsModule_Chip_Level__get_Foreground(this$) {
    switch (this$.tag) {
        case 1:
            return "var(--alerts-positive-dark)";
        case 2:
            return "var(--alerts-warning-minor-dark)";
        case 3:
            return "var(--alerts-warning-dark)";
        case 4:
            return "var(--alerts-critical-warning-dark)";
        case 5:
            return "var(--alerts-neutral-dark)";
        default:
            return "var(--alerts-information-dark)";
    }
}

export function ComponentsModule_Chip_Level__get_Background(this$) {
    switch (this$.tag) {
        case 1:
            return "var(--alerts-positive-light)";
        case 2:
            return "var(--alerts-warning-minor-light)";
        case 3:
            return "var(--alerts-warning-light)";
        case 4:
            return "var(--alerts-critical-warning-light)";
        case 5:
            return "var(--alerts-neutral-light)";
        default:
            return "var(--alerts-information-light)";
    }
}

export function Components_Chip_51BC9844(components_Chip_51BC9844InputProps) {
    const colorLevel = components_Chip_51BC9844InputProps.colorLevel;
    const onClick = components_Chip_51BC9844InputProps.onClick;
    const startIcon = components_Chip_51BC9844InputProps.startIcon;
    const backgroundColor = components_Chip_51BC9844InputProps.backgroundColor;
    const color = components_Chip_51BC9844InputProps.color;
    const enabled = components_Chip_51BC9844InputProps.enabled;
    const secondary = components_Chip_51BC9844InputProps.secondary;
    const primary = components_Chip_51BC9844InputProps.primary;
    const key = components_Chip_51BC9844InputProps.$key;
    const enabled_1 = defaultArg(enabled, false);
    const colorLevel_1 = defaultArg(colorLevel, new ComponentsModule_Chip_Level(0, []));
    const color_1 = defaultArg(color, ComponentsModule_Chip_Level__get_Foreground(colorLevel_1));
    const backgroundColor_1 = defaultArg(backgroundColor, ComponentsModule_Chip_Level__get_Background(colorLevel_1));
    return createElement("div", createObj(toList(delay(() => append(singleton(["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => append(singleton(["color", color_1]), delay(() => append(enabled_1 ? singleton(["backgroundColor", backgroundColor_1]) : append(singleton(["backgroundColor", "rgba(0, 0, 0, 0)"]), delay(() => singleton(["border", (((2 + "px ") + "solid") + " ") + color_1]))), delay(() => append(singleton(["columnGap", 5 + "px"]), delay(() => append(singleton(["padding", ((((((5 + "px ") + 10) + "px ") + 5) + "px ") + 10) + "px"]), delay(() => append(singleton(["borderRadius", 20 + "px"]), delay(() => ((onClick != null) ? singleton(["cursor", "pointer"]) : empty()))))))))))))))))))]), delay(() => {
        let matchValue, f;
        return append((matchValue = onClick, (matchValue != null) ? ((f = matchValue, singleton(["onClick", (ev) => {
            console.debug("Chip on click:", ev);
            f();
        }]))) : (empty())), delay(() => {
            let elems;
            return singleton((elems = toList(delay(() => {
                let matchValue_1;
                return append((matchValue_1 = startIcon, (matchValue_1 != null) ? singleton(matchValue_1([["style", {
                    width: 20 + "px",
                    height: 20 + "px",
                }]])) : singleton(defaultOf())), delay(() => append(singleton(MuiHelpers_createElement(Typography, [["variant", "body3-bold"], ["noWrap", true], ["children", primary]])), delay(() => {
                    let matchValue_2, txt;
                    return append((matchValue_2 = secondary, (matchValue_2 != null) ? ((txt = matchValue_2, singleton(createElement("div", {
                        style: {
                            backgroundColor: "#FFFFFF",
                            borderRadius: ((((((0 + "px ") + 20) + "px ") + 20) + "px ") + 0) + "px",
                            padding: ((((((0 + "px ") + 10) + "px ") + 0) + "px ") + 5) + "px",
                        },
                        children: txt,
                    })))) : (empty())), delay(() => {
                        let props_3;
                        return ((onClick != null) && enabled_1) ? singleton((props_3 = {
                            style: {
                                width: 16 + "px",
                                height: 16 + "px",
                            },
                        }, react.createElement(Cancel, props_3))) : empty();
                    }));
                }))));
            })), ["children", reactApi.Children.toArray(Array.from(elems))]));
        }));
    }))))));
}

